var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModalDivideLine = function SvgModalDivideLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 325,
    height: 1,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#9598AB",
    d: "M0 .5h325",
    opacity: 0.2
  })));
};
export { SvgModalDivideLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzI1IiBoZWlnaHQ9IjEiIHZpZXdCb3g9IjAgMCAzMjUgMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgb3BhY2l0eT0iMC4yIiB5MT0iMC41IiB4Mj0iMzI1IiB5Mj0iMC41IiBzdHJva2U9IiM5NTk4QUIiLz4KPC9zdmc+Cg==";